module.exports = __webpack_public_path__ + "6d9d987d7370e72a8403cb4270f3c1de.png";


//////////////////
// WEBPACK FOOTER
// ./assets/LogoMini.png
// module id = 835
// module chunks = 66